import axios from '../base/axios';
import API_KEY from './key';

const GET_TVSOAP = 'flixfrenzy/redux/GET_TVSOAP';

// eslint-disable-next-line default-param-last
const tvSoapReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVSOAP:
      return action.payload;
    default:
      return state;
  }
};

export const getTvSoap = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_genres=10766`).then((res) => {
    dispatch({
      type: GET_TVSOAP,
      payload: res.data,
    });
  });
};

export default tvSoapReducer;
